import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteItem,
  fetchPaginationData,
  updateStatus,
} from "../../utils/apiUtils";
import DeleteModel from "../../Components/DeleteModel";
import Spinner from "../../Components/spinner";
import Breadcrumb from "../../Components/Breadcrumb";
import Pagination from "../../Components/Pagination";
import {
  ActionButton,
  PlusButton,
  ToggleSwitch,
} from "../../Components/TableHelper";
import { formatDate } from "../../utils/constant";
import PerPageSelect from "../../Components/PerPageSelect";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
const PriceList = () => {
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [nextSortOrder, setNextSortOrder] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [priceValues, setPriceValues] = useState({});
  const [updatingId, setUpdatingId] = useState(null);
  const navigator = useNavigate();

  const fetchDataPagination = async (
    page = 1,
    currentSearch = "",
    currentPerPage = perPage,
  ) => {
    const requestData = {
      perPage: currentPerPage,
      pageNo: page,
      search: currentSearch,
    };
    await fetchPaginationData(
      "priceList/getAllPriceLists",
      requestData,
      setdata,
      setTotalCount,
      setCurrentPage,
      setLoading,
      setNextSortOrder,
    );
  };
  useEffect(() => {
    fetchDataPagination(1);
  }, []);
  useEffect(() => {
    const obj = {};
    data.forEach((item) => {
      obj[item._id] = item.price;
    });
    setPriceValues(obj);
  }, [data]);
  const handlePerPageChange = (value) => {
    setPerPage(value);
    fetchDataPagination(1, "", value);
  };
  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "priceList/deletePriceList",
        deleteItemId?._id,
        fetchDataPagination,
      );
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const handleStatusToggle = async (item) => {
    const updated = await updateStatus(item?._id, "priceList", !item?.isActive);
    if (!updated) return;
    setdata((prev) =>
      prev.map((curr) =>
        curr._id === updated._id
          ? { ...curr, isActive: updated.isActive }
          : curr,
      ),
    );
  };

  const updatePrice = async (data) => {
    try {
      setUpdatingId(data?._id);

      const payload = {
        sortOrder: data.sortOrder,
        isActive: data.isActive,
        country_id: data.country_id?._id || null,
        category_id: data.category_id?._id || null,
        priceType_id: data.priceType_id?._id || null,
        quality_id: data.quality_id?._id || null,
        traceability_id: data.traceability_id?._id || null,
        packSize_id: data.packSize_id?._id || null,
        packBag_id: data.packBag_id?._id || null,

        price: priceValues[data._id],
      };
      const response = await axiosInstance.put(
        `/priceList/updatePriceList/${data?._id}`,
        payload,
      );

      toast.success(response.data.message || "Price updated successfully");

      setdata((prev) =>
        prev.map((item) =>
          item._id === data?._id
            ? { ...item, price: Number(priceValues[data?._id]) }
            : item,
        ),
      );
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setUpdatingId(null);
    }
  };

  const handleAdd = () => {
    navigator("/add-price-list", { state: { sortOrder: nextSortOrder } });
  };
  const handleEditClick = (item) => {
    navigator("/add-price-list", {
      state: item,
    });
  };

  const Tableheader = [
    "Sort Order",
    "Country",
    "Price Type",
    "Category",
    "Pack Bag",
    "Pack Size",
    "Price",
    "Status",
    "Last Updated",
    "Action",
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Price List", path: "/price-list" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="custom-page-title">Price List</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="d-flex justify-content-between align-items-center bg-white p-2 mt-n2 flex-wrap gap-2">
         <div className="d-flex align-items-center" style={{ gap: "20px" }}>
  <PerPageSelect value={perPage} onChange={handlePerPageChange} />
  <h4 className="mb-0">All prices are in US Dollars</h4>
</div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <PlusButton handleAdd={handleAdd} module={"Price Type"} />
          </div>
        </div>

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className=" custom-table table table-striped"
                    id="slidertable"
                  >
                    <thead>
                      <tr>
                        {Tableheader.map((item, index) => (
                          <th className="font-weight-bold " key={index}>
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : data?.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{item.sortOrder}</td>
                            <td>{item?.country_id?.countryName}</td>
                            <td>{item?.priceType_id?.priceTypeCode}</td>
                            <td>
                              {[
                                item?.category_id?.categoryName,
                                item?.quality_id?.qualityName,
                                item?.traceability_id?.traceabilityName,
                                item?.product_id?.productTitle,
                              ]
                                .filter((val) => val && val !== "null")
                                .join(", ")}
                            </td>
                            <td>{item?.packBag_id?.packBagName}</td>
                            <td>{item?.packSize_id?.packSizeName}</td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm text-center"
                                style={{
                                  width: "80px",
                                  minWidth: "80px",
                                  height: "30px",
                                  padding: "2px 6px",
                                  fontSize: "13px",
                                }}
                                disabled={updatingId === item._id}
                                value={priceValues[item._id] ?? ""}
                                onChange={(e) =>
                                  setPriceValues((prev) => ({
                                    ...prev,
                                    [item._id]: e.target.value,
                                  }))
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    updatePrice(item);
                                  }
                                }}
                              />
                            </td>
                            <td>
                              <ToggleSwitch
                                data={item}
                                name="isActive"
                                checked={item.isActive}
                                handleStatusToggle={handleStatusToggle}
                                module={"Price List"}
                              />
                            </td>
                            <td>{formatDate(item.updatedAt)}</td>
                            <td>
                              <ActionButton
                                data={item}
                                handleEditClick={handleEditClick}
                                handleDelete={handleDelete}
                                module={"Price List"}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {data?.length > 0 && (
                  <div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="Price List"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default PriceList;
